/* DSL Klaviyo flow triggers — emit standard ecommerce events naar Klaviyo */
(function(){
  function track(name, props){
    if (window.klaviyo && typeof window.klaviyo.track === "function") {
      try { window.klaviyo.track(name, props); } catch(e){}
    }
  }
  // Viewed Product
  if (location.pathname.indexOf("/products/") === 0) {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (m) {
      var handle = m[1];
      fetch("/products/" + handle + ".js").then(function(r){return r.json();}).then(function(p){
        track("Viewed Product", {ProductID: p.id, Name: p.title, Brand: p.vendor, Price: p.price/100, ProductURL: location.href, ImageURL: p.featured_image});
      });
    }
  }
  // Added to Cart
  document.addEventListener("dsl:cart:add", function(e){
    var d = e.detail || {};
    track("Added to Cart", {ProductID: d.product_id, Name: d.product_title, Price: (d.price||0)/100, Quantity: d.quantity||1});
  });
  // Started Checkout
  if (location.pathname === "/cart") {
    fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
      if (c.item_count > 0) track("Started Checkout", {Total: c.total_price/100, ItemCount: c.item_count, Items: c.items.map(function(i){return {Name: i.product_title, Price: i.price/100, Quantity: i.quantity};})});
    });
  }
  // Searched
  if (location.pathname.indexOf("/search") === 0) {
    var q = new URLSearchParams(location.search).get("q");
    if (q) track("Searched Site", {Search: q});
  }
})();